export default "__VITE_ASSET__DCN3V4AU__"